import { AgsResultBuilder as AgsResultBuilder } from "ags/integration/builders/results/abstract-ags-result-builder";
import { AgsWin, AgsWinTypes } from "ags/integration/schema/ags-spin-response-schema";
import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { Point } from "appworks/utils/geom/point";
import { ScatterResult } from "slotworks/model/gameplay/records/results/scatter-result";
import { slotDefinition } from "slotworks/model/slot-definition";

export class ScatterResultBuilder extends AgsResultBuilder implements ResultBuilder {
    public filter(data: any): boolean {
        const win = data as AgsWin;
        return win.winType && (win.winType === AgsWinTypes.SCATTER || win.winType === this.evaluationTypeAlias);
    }

    public build(record: Record, data: any): Result[] {
        const agsWin = data as AgsWin;
        const symbolDef = slotDefinition.symbolDefinitions[agsWin.symbolId];

        const result = new ScatterResult();
        result.symbolType = symbolDef.id;
        result.cashWon = agsWin.winAmount;

        result.positions = agsWin.winningSymbolsPositions
            .map((coords: number[]) => new Point(coords[0], coords[1]));
        result.matches = result.positions.length;

        const freespinResults = this.processFreespinData(record, data, result);

        return [result, ...freespinResults];
    }
}
